import { render, staticRenderFns } from "./BookingDetailViewMobile.vue?vue&type=template&id=1bfeec58"
import script from "./BookingDetailViewMobile.vue?vue&type=script&lang=js"
export * from "./BookingDetailViewMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports